import { useContext, useState } from "react";
import {Modal, Button} from "react-bootstrap";
import AuthContext from "../context/authContext";
import useIdleTimeout from "../hooks/useIdleTimeout";
import { useNavigate } from "react-router-dom";
import './timeoutDialog.css';

const TimeOutDialog = () => {
    let navigate = useNavigate();
    let timeoutID;

    const [openModal, setOpenModal] = useState(false)
    const { logout } = useContext(AuthContext);
    
    const handleIdle = () => {
        setOpenModal(true);
    }
    
    const stay = () => {
        clearTimeout(timeoutID);
        console.log('Clear Dialog Timeout');
        idleTimer.reset();
        console.log('Timer Reset');
        setOpenModal(false);
    }

    const handleLogout = () => {
        logout();
        setOpenModal(false);
        navigate("/", {state: {id:3, name:"SessionTimeOut", loginResult: null}});
    }

    const handleOnOpenModal = () => {
        timeoutID = setTimeout(() =>{
            window.location.href = "/";
        }, 36000);
    }
    
    const cutomStlyles = {
        content:{postion:'fixed'},
        overlay: {zIndex: 9999}
    };

       
    const {idleTimer} = useIdleTimeout({ 
        onIdle: handleIdle, 
        idleTime: 1 
    });
    console.log("Set idleTimer: ", idleTimer);

    const clearAll = () => {
        console.log("Clear All Timeouts");
    }

    return(
        <>
        <Modal show={openModal} onHide={clearAll}  style={cutomStlyles} onShow={handleOnOpenModal}> 
            <Modal.Header >
                <Modal.Title>Your session is about to expire</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Your session is about to expire. You'll be automatically signed out.
                </p>
                <p>
                    Do you want to stay signed in?
                </p>

            </Modal.Body>
            <Modal.Footer className="ModalFooter">
                <Button variant="secondary" onClick={handleLogout}>
                    Sign out now
                </Button>
                <Button variant="primary" onClick={stay}>
                    Stay signed in
                </Button>
            </Modal.Footer>
        </Modal>
        </>
    );
}

export default TimeOutDialog;